import { Trash2, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';

export function BulkSelectCheckbox({ checked, onCheckedChange, testId }) {
  return (
    <Checkbox
      checked={checked}
      onCheckedChange={onCheckedChange}
      className="border-gray-300"
      data-testid={testId}
    />
  );
}

export function BulkActionBar({ count, onDelete, onClear, label = 'items' }) {
  if (count === 0) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 bg-[#0A0A0A] text-white px-5 py-3 rounded-lg shadow-2xl flex items-center gap-4 animate-in slide-in-from-bottom-4" data-testid="bulk-action-bar">
      <span className="text-sm font-medium">{count} {label} selected</span>
      <Button
        size="sm"
        variant="destructive"
        className="bg-red-600 hover:bg-red-700 text-white text-xs h-8"
        onClick={onDelete}
        data-testid="bulk-delete-btn"
      >
        <Trash2 className="w-3.5 h-3.5 mr-1.5" /> Delete Selected
      </Button>
      <button onClick={onClear} className="text-zinc-400 hover:text-white" data-testid="bulk-clear-btn">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
